<div class="container my-5">
  <div class="page-header mb-4">
    <ng-container *ngIf="!formGroup.get('id')?.value; else elseUpdate">
      <h1 class="page-title">Cadastro de Funcionário</h1>
    </ng-container>
    <ng-template #elseUpdate>
      <h1 class="page-title">Alterar Funcionário</h1>
    </ng-template>
  </div>

  <div *ngIf="isSaving" class="backdrop">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div id="fullPageContent" class="form-container">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <!-- Seção: Informações Básicas -->
      <mat-card class="form-section-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>person</mat-icon>
            Informações Básicas
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="form-row">
            <div class="form-col">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Nome Completo</mat-label>
                <input matInput formControlName="name" placeholder="Seu nome" />
                <mat-icon matPrefix>person</mat-icon>
                <mat-error *ngIf="formGroup.get('name')?.invalid && formGroup.get('name')?.touched">
                  O nome é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-col">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email" placeholder="Seu email" />
                <mat-icon matPrefix>email</mat-icon>
                <mat-error *ngIf="formGroup.get('email')?.invalid && formGroup.get('email')?.touched">
                  <span *ngIf="formGroup.get('email')?.errors?.['required']">O email é obrigatório.</span>
                  <span *ngIf="formGroup.get('email')?.errors?.['email']">Email inválido.</span>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-col">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Nome de usuário</mat-label>
                <input
                  matInput
                  formControlName="username"
                  (input)="onInputChange()"
                  placeholder="Seu usuário de acesso"
                />
                <mat-icon matPrefix>account_circle</mat-icon>
                <mat-error *ngIf="formGroup.get('username')?.invalid && formGroup.get('username')?.touched">
                  O nome de usuário é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Seção: Informações Organizacionais -->
      <mat-card class="form-section-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>business</mat-icon>
            Informações Organizacionais
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="form-row">
            <div class="form-col">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Empresa</mat-label>
                <mat-select formControlName="officeId" (selectionChange)="onOfficeChange($event)">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let office of offices" [value]="office['id']">{{ office["name"] }}</mat-option>
                </mat-select>
                <mat-icon matPrefix>business</mat-icon>
                <mat-error *ngIf="formGroup.get('officeId')?.invalid && formGroup.get('officeId')?.touched">
                  A empresa é obrigatória.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-col">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Cargo</mat-label>
                <mat-select
                  formControlName="responsibilityId"
                  (selectionChange)="onResponsibilityChange($event)"
                  [disabled]="!formGroup.get('officeId')?.value"
                >
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let responsibility of responsibilities" [value]="responsibility['id']">
                    {{ responsibility["name"] }}
                  </mat-option>
                </mat-select>
                <mat-icon matPrefix>work</mat-icon>
                <mat-hint *ngIf="!formGroup.get('officeId')?.value">Selecione uma empresa primeiro</mat-hint>
                <mat-error
                  *ngIf="formGroup.get('responsibilityId')?.invalid && formGroup.get('responsibilityId')?.touched"
                >
                  O cargo é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-col">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Tipo de Acesso</mat-label>
                <mat-select formControlName="accessType">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option value="User">Usuário Comum</mat-option>
                  <mat-option value="Supervisor">Supervisor</mat-option>
                  <mat-option value="Manager">Gerente</mat-option>
                </mat-select>
                <mat-icon matPrefix>security</mat-icon>
                <mat-error *ngIf="formGroup.get('accessType')?.invalid && formGroup.get('accessType')?.touched">
                  O tipo de acesso é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Campos Condicionais -->
          <div class="form-row" *ngIf="formGroup.get('accessType').value">
            <div class="form-col" [hidden]="formGroup.get('accessType').value != 'User'">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Supervisor</mat-label>
                <mat-select formControlName="supervisorId" (selectionChange)="onSupervisorChange($event)">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let supervisor of supervisors" [value]="supervisor['id']">
                    {{ supervisor["name"] }}
                  </mat-option>
                </mat-select>
                <mat-icon matPrefix>supervisor_account</mat-icon>
                <mat-error *ngIf="formGroup.get('supervisorId')?.invalid && formGroup.get('supervisorId')?.touched">
                  O supervisor é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-col" [hidden]="formGroup.get('accessType').value != 'Supervisor'">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Gerente</mat-label>
                <mat-select formControlName="managerId" (selectionChange)="onManagerChange($event)">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let manager of managers" [value]="manager['id']">{{
                    manager["name"]
                  }}</mat-option>
                </mat-select>
                <mat-icon matPrefix>admin_panel_settings</mat-icon>
                <mat-error *ngIf="formGroup.get('managerId')?.invalid && formGroup.get('managerId')?.touched">
                  O gerente é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Seção: Foto do Colaborador -->
      <mat-card class="form-section-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>photo_camera</mat-icon>
            Foto do Colaborador
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="photo-section">
            <div class="photo-upload-section">
              <div class="file-upload-container">
                <div class="file-input-wrapper">
                  <input
                    type="file"
                    id="picture"
                    formControlName="picture"
                    accept="image/*"
                    (change)="onFileSelected($event)"
                    #fileInput
                    class="file-input"
                  />
                  <button mat-stroked-button type="button" (click)="fileInput.click()" class="file-button">
                    <mat-icon>photo_camera</mat-icon>
                    Selecionar Foto
                  </button>
                  <span *ngIf="fileInput.files && fileInput.files.length > 0" class="file-name">
                    {{ fileInput.files[0].name }}
                  </span>
                </div>
                <div *ngIf="formGroup.get('picture')?.invalid && formGroup.get('picture')?.touched" class="file-error">
                  A foto é obrigatória.
                </div>
              </div>
            </div>

            <div class="photo-preview-section">
              <div *ngIf="imageUrl" class="photo-preview">
                <img [src]="imageUrl" alt="Foto do Colaborador" />
              </div>
              <div *ngIf="!imageUrl" class="photo-placeholder">
                <mat-icon>image</mat-icon>
                <span>Nenhuma foto selecionada</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Botões de Ação -->
      <div class="form-actions" *ngIf="!isSaving">
        <button mat-raised-button color="primary" type="submit" [disabled]="formGroup.invalid" class="submit-button">
          <mat-icon>save</mat-icon>
          Salvar
        </button>
      </div>

      <div *ngIf="isSaving" class="spinner-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    </form>
  </div>
</div>
